/**
 * FieldGrid - Reusable grid layouts for fields
 * Provides common grid patterns used in forms and detail views
 */
export default function FieldGrid({ columns = 2, children, className = '' }) {
  const gridClasses = {
    1: 'grid grid-cols-1',
    2: 'grid grid-cols-2 gap-6 max-lg:gap-4',
    3: 'grid grid-cols-1 md:grid-cols-3 gap-4 max-lg:gap-3',
    actions: 'grid grid-cols-1 md:grid-cols-2 gap-3 max-lg:gap-2'
  };

  const gridClass = gridClasses[columns] || gridClasses[2];

  return (
    <div className={`${gridClass} ${className}`}>
      {children}
    </div>
  );
}
